import React, { FC } from "react";
import injectSheet from "react-jss";
import Loader from "./Loader";
import options from "./options";
import styleSheet from "./styles";

interface Props {
  classes?: any;
  isFullscreen?: boolean;
}

const Loading: FC<Props> = (props: Props) => {
  const { classes, isFullscreen } = props;

  return (
    <div className={isFullscreen ? classes.fullscreenLoader : classes.loader}>
      <Loader animationData={options.loading1} />
    </div>
  );
};

Loading.defaultProps = {
  classes: {},
  isFullscreen: false,
};

export default injectSheet(styleSheet)(Loading);
